module.exports = __webpack_public_path__ + "img/NoPath1x.39c46e78.png";